import React from 'react';
import Table from '../../components/Table';
import { useMeasurements } from 'hooks/useMeasurements';

function Measurements() {
  const {
    measurements,
    columns,
    columnsForExport,
    exportData,
    openProgress,
    errors,
    errorsWhenPosting,
    handleCloseSnackbar,
    handleImportDataPost,
  } = useMeasurements();

  return (
    <Table
      onPost={handleImportDataPost}
      title="Qualidade da Água"
      route="/measurements/"
      routeAdd="/measurement/"
      columns={columns}
      columnsForExport={columnsForExport}
      data={measurements}
      dataLoaded={openProgress}
      exportData={exportData}
      hasError={errors.length > 0}
      importButtonVisible
      errorsPost={errorsWhenPosting}
      onCloseSnackbar={handleCloseSnackbar}
    />
  );
}

export default Measurements;
